import styled from "styled-components";

const SelectBox = styled.select`
  padding: 12px 12px;
  border-radius: 12px;
  border: 1px solid #C2C8CF;
  background: #ffffff;
  color: #000000;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #DE644E;
  }
`;

export function Select({ value, onChange, children, ...props }) {
  return (
    <SelectBox value={value} onChange={onChange} {...props}>
      {children}
    </SelectBox>
  );
}